import React from 'react';
import { _t } from '../utils/translations'

interface IProps {
  onReload: () => void;
}

const FailedToLoadData: React.FC<IProps> = ({ onReload }) => (
  <div>
    {_t('Failed to load data')}
    {' '}
    <button type="button" onClick={onReload}>
      {_t('Reload')}
    </button>
  </div>
);

export default FailedToLoadData;
